import { IPatient } from './patient.model';
import { IMeeting } from './meeting.model';
import { IReview } from './review.model';
import { IDoctor } from './doctor.model';
import {ICustomer} from "./customer.model";
import {ITransaction} from "./transaction.model";
import {IProject} from "./project.model";
import {IEmployee} from "./employee.model";
import {ISalesCycle} from "./salesCycle.model";
import {ITicket} from "./ticket.model";
import {IClient} from "./client.model";
import {IAnswer} from "./answer.model";
import {IOrder} from "./order.model";
import {IContract} from "./contract.model";
import {IOrderBuy} from "./orderBuy.model";
import {IFactor} from "./factor.model";
import {ISupplier} from "./supplier.model";

export interface IFileObject {
  id?: number;
  contentType_s?: string;
  contentType?: string;
  content?: any;
  content_s?: any;
  itemName?: any;
  itemName_s?: any;
  type?: any;
  date?: any;
  factor_date_str?: any;
  uploaded?: any;
  amount?: any;
  factor_amount_total_number?: any;
  factor_supplier_amount_total_number?: any;
  amount_s?: any;
  title_s?: any;
  status?: any;
  size?: any;
  size_s?: any;
  title?: any;
  description?: any;
  amazonId?: any;
  amazonLink?: any;
  isImgProfile?: boolean;
  imgProfile?: boolean;
  isdeleted?: boolean;
  uploaded_by?: any;

  // patient?: IPatient;
  // doctor?: IDoctor;
  // meeting?: IMeeting;
  // reviews?: IReview[];
  project?: IProject;
  factor?: IFactor;
  contract?: IContract;
  salesCycle?: ISalesCycle;
  transaction?: ITransaction;
  customer?: ICustomer;
  supplier?: ISupplier;
  supplier_id?: any;
  order?: IOrder;
  orderBuy?: IOrderBuy;
  ticket?: ITicket;
  answer?: IAnswer;
  employee?: IEmployee;
  client?: IClient;
  createdDate?: any;
  createdBy?: any;
  lastModifiedDate?: any;

}

export class FileObject implements IFileObject {
  constructor(public id?: number, public contentType?: string, public content?: any,
              public title?: any, public description?: any, public amazonLink?: any
    , public size?: any
    , public itemName?: any
    , public itemName_s?: any
    , public status?: any
    , public type?: any
    , public amount?: any
    , public amount_s?: any
    , public title_s?: any
    , public uploaded_by?: any
    , public amazonId?: any
    , public isImgProfile?: boolean
    , public imgProfile?: boolean
    , public isdeleted?: boolean
    , public customer?: ICustomer
    , public supplier?: ISupplier
    , public supplier_id?: any
    , public order?: IOrder
    , public orderBuy?: IOrderBuy
    , public ticket?: ITicket
    , public employee?: IEmployee
    , public project?: IProject
    , public contract?: IContract
    , public salesCycle?: ISalesCycle
    , public transaction?: ITransaction
  ) {
  }
}
